import React from "react";
import { Box, Flex, Heading, Link, Text } from "@chakra-ui/react";
import { IBulletin } from "@iloq/shared";
import { FormattedMessage } from "react-intl";
import { DateTime } from "luxon";

export function BulletinList({
  bulletinList,
  locale,
}: {
  bulletinList: IBulletin[];
  locale: string;
}): React.ReactNode {
  return (
    <main>
      <Flex mt="4xl" mx={{ base: "-30px", sm: "0" }} flexDir="column" gap="3xl">
        <Heading
          as="h1"
          color="brand.purpleDark"
          data-cy="list-bulletin-title"
          ml={{ base: "15px", sm: "0" }}
          mt="4xl"
          mb="xl"
          height="16"
        >
          <FormattedMessage id="bulletin.listBulletin" />
        </Heading>

        {/* BULLETIN CARDS */}
        {bulletinList.map((bulletin) => (
          <Link
            key={bulletin.id}
            href={`/bulletin/${bulletin.id}`}
            display="flex"
            background="white"
            maxWidth="4xl"
            borderRadius={{ base: "none", sm: "base" }}
            boxShadow={{ base: "none", sm: "base" }}
            _hover={{
              textDecoration: "none",
              color: "brand.purpleDark",
            }}
          >
            <Flex
              flexDirection={{ base: "column", sm: "row" }}
              width="100%"
              padding={{ base: "md", sm: "2xl" }}
            >
              <Box
                borderRadius="sharper"
                style={{
                  backgroundImage: bulletin.featured_image_url
                    ? `url(${bulletin.featured_image_url})`
                    : "none",
                }}
                backgroundRepeat="no-repeat"
                backgroundPosition="center center"
                backgroundSize="cover"
                width="400px"
                height="200px"
                maxHeight="100%"
                maxWidth="100%"
                mr={{ base: "0", sm: "xl" }}
              />
              <Box>
                <Text mt="18px" mb="xl" color="brand.purple">
                  {DateTime.fromISO(bulletin.date).isValid
                    ? DateTime.fromISO(bulletin.date)
                        .setLocale(locale)
                        .toLocaleString(DateTime.DATE_SHORT)
                    : ""}
                </Text>
                <Heading
                  as="h2"
                  fontSize="2xl"
                  dangerouslySetInnerHTML={{ __html: bulletin.title }}
                ></Heading>
              </Box>
            </Flex>
          </Link>
        ))}
      </Flex>
    </main>
  );
}
